import { schema as schemas } from 'normalizr'
import qs from 'qs'

import { CallApi } from '@signavio/kraken'

import { Workflow } from '../../../types'

import { LABELS } from '../organizations'
import { USER } from '../users'

export const collection = 'workflows'

export const schema = new schemas.Entity(collection, {
  owner: USER.schema,
  editor: USER.schema,
  labels: LABELS.schema,
})

type FetchQueryType = {
  id: string
}

export const fetch =
  (callApi: CallApi, apiBase: string) =>
  ({ id }: FetchQueryType) =>
    callApi(`${apiBase}/workflows/${id}`, schema)

type UpdateQueryType = {
  id: string
}

export const update =
  (callApi: CallApi, apiBase: string) =>
  ({ id }: UpdateQueryType, workflow: Workflow) =>
    callApi(`${apiBase}/workflows/${id}`, schema, {
      method: 'PUT',
      body: workflow,
    })

export const create =
  (callApi: CallApi, apiBase: string) =>
  (_: unknown, workflowStub: Partial<Workflow>) =>
    callApi(`${apiBase}/workflows`, schema, {
      method: 'POST',
      body: workflowStub,
    })

type RemoveQueryType = {
  id: string
}

export const remove =
  (callApi: CallApi, apiBase: string) =>
  ({ id }: RemoveQueryType, cascade: boolean) =>
    callApi(
      `${apiBase}/workflows/${id}${qs.stringify(
        {
          cascade,
        },

        {
          addQueryPrefix: true,
        }
      )}`,
      schema,
      {
        method: 'DELETE',
        body: { id },
      }
    )
